module.exports = __webpack_public_path__ + "static/media/two-occupants.35e8f6e0.svg";